import React from "react";
import { ReactComponent as Cancel } from "../../../../../assets/images/cancel.svg";
import { Button } from "../../../../../components";
import InfoCard from "./info-card";
import "./recommendations.css";

export interface RecommendationContent {
    title: string;
    cardTitle: string;
    cardDescription: string;
    whyThisResultTitle: string;
    whyThisResult: string;
    whatToDoNow: string;
    whatToDoNowTitle: string;
    ctaLabel: string;
}

interface OutcomeRecommendationLayoutProps {
    content: RecommendationContent;
    onSubmit: () => void;
}

export default function OutcomeRecommendationLayout({
    content,
    onSubmit,
}: OutcomeRecommendationLayoutProps): React.ReactElement {
    return (
        <section className="hpv-recommendations__layout">
            <h2 className="hpv-recommendations__heading">{content.title}</h2>

            <InfoCard Icon={Cancel} title={content.cardTitle}>
                {content.cardDescription}
            </InfoCard>

            <div className="hpv-recommendations__body">
                <section className="hpv-recommendations__section">
                    <h3 className="hpv-recommendations__title">
                        {content.whyThisResultTitle}
                    </h3>
                    <p className="hpv-recommendations__paragraph">
                        {content.whyThisResult}
                    </p>
                </section>

                <section className="hpv-recommendations__section">
                    <h3 className="hpv-recommendations__title">
                        {content.whatToDoNowTitle}
                    </h3>
                    <p className="hpv-recommendations__paragraph">
                        {content.whatToDoNow}
                    </p>
                </section>
            </div>

            <Button
                className="hpv-recommendations__button hpv-recommendations__button--secondary"
                onClick={onSubmit}
            >
                {content.ctaLabel}
            </Button>
        </section>
    );
}
